import dayjs from 'dayjs';
import { getEnvs } from './environments';

export function getFixedDateEnv() {
  const envs = getEnvs();
  return envs.REACT_APP_DEMO_FIXED_DATE;
}

export function isFixedDayMode() {
  return Boolean(getFixedDateEnv());
}

export function getFixedDay() {
  const v = getFixedDateEnv();
  if (!v) return null;
  const d = dayjs(v);
  return d.isValid() ? d : null;
}

export function getNow() {
  const fixed = getFixedDay();
  if (fixed) return fixed;
  return dayjs();
}
